import React, { useEffect, useState } from 'react';
import api from '../api/client';
interface Props { paymentId: number; onBack: () => void; }
export default function SupplierPaymentDetail({ paymentId, onBack }: Props) {
  const [pay, setPay] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const fmt = (n: any) => Number(n||0).toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });
  useEffect(() => {
    api.get(`/supplier-payments/${paymentId}`).then(r => { setPay(r.data.data); setLoading(false); });
  }, [paymentId]);
  if (loading) return <div className="empty-state"><p>Loading...</p></div>;
  if (!pay) return <div className="empty-state"><p>Not found.</p></div>;
  return (
    <div>
      <div className="page-header" id="no-print">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button className="btn btn-primary" onClick={() => window.print()}>Print</button>
      </div>
      <div className="card" id="print-area">
        <div style={{ padding:'20px 24px', borderBottom:'1px solid var(--bdr)', display:'flex', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:20, fontWeight:700 }}>Supplier Payment</div>
            <div style={{ fontSize:12, color:'var(--tx3)', marginTop:4 }}>#{pay.id} &mdash; {pay.branch_name}</div>
          </div>
          <div style={{ textAlign:'right', fontSize:12, color:'var(--tx3)' }}>
            <div>Date: {pay.paid_at ? new Date(pay.paid_at).toLocaleDateString() : '-'}</div>
            <div>Ref: {pay.payment_ref || '-'}</div>
          </div>
        </div>
        <div style={{ padding:'16px 24px', borderBottom:'1px solid var(--bdr)' }}>
          <div style={{ fontSize:12, color:'var(--tx3)', marginBottom:4 }}>Supplier</div>
          <div style={{ fontWeight:600 }}>{pay.supplier_name}</div>
        </div>
        <div style={{ padding:'16px 24px', borderBottom:'1px solid var(--bdr)' }}>
          <div style={{ fontSize:12, color:'var(--tx3)', marginBottom:4 }}>Account</div>
          <div style={{ fontWeight:600 }}>{pay.account_code} - {pay.account_name}</div>
        </div>
        <div style={{ padding:'24px', display:'flex', justifyContent:'flex-end' }}>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:13, color:'var(--tx3)', marginBottom:4 }}>Amount Paid</div>
            <div style={{ fontSize:28, fontWeight:700, color:'var(--red)' }}>{fmt(pay.amount)}</div>
          </div>
        </div>
      </div>
      <style>{`@media print { #no-print { display:none !important; } }`}</style>
    </div>
  );
}